var moment = require('moment')
var momentDurationFormatSetup = require('moment-duration-format')

momentDurationFormatSetup(moment)
typeof moment.duration.fn.format === 'function'
typeof moment.duration.format === 'function'


export function formatDuration(duration) {
  if(duration == 0) {
    return "N/A"
  }else if(Math.abs(duration) < 2628000000.00){
    return "< 1 mos"
  }else{
    return moment.duration(duration, "milliseconds").format("y [yrs] M [mos]")
  }
}
